import { Navigate } from 'react-router-dom';

import SupportTickets from '../../pages/support-tickets';

import { useSupportAiBotFeatureFlag } from './useSupportAiBotFeatureFlag';

/** Keeps deep links closed until PostHog resolves the release flag. */
export function SupportTicketsFeatureRoute() {
  const { enabled, isLoading } = useSupportAiBotFeatureFlag();

  if (isLoading) return null;
  return enabled ? <SupportTickets /> : <Navigate to="/profile" replace />;
}
